import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { SELECT_PORTFOLIO } from '../../constant'

const initialState = {
  typePortfolioSelect: SELECT_PORTFOLIO[0],
  isFragment: false,
  nameCompany: '',
}

const slice = createSlice({
  name: 'library/savedPortfolios/component',
  initialState,
  reducers: {
    clearStoreComponent(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeTypePortfolio: (state, action) => {
      state.typePortfolioSelect = action.payload
    },
    changeFragment: (state) => {
      state.isFragment = !state.isFragment
    },
    changeNameCompany: (state, action) => {
      state.nameCompany = action.payload
    },
  },
  extraReducers: {},
})

//main
export const selectFragment = (state) => state[slice.name].isFragment

export const selectTypePortfolioSelect = (state) =>
  state[slice.name].typePortfolioSelect

export const selectNameCompanySearch = (state) => state[slice.name].nameCompany

export const {
  changeTypePortfolio,
  changeFragment,
  changeNameCompany,
  clearStoreComponent,
} = slice.actions

register(slice.name, slice.reducer)
